// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Component } from '@angular/core';


// LOCALS
//-------------------------------------------------------------------------------------------------------------------------


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// TaggingComponent
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Component({
  template : '<router-outlet></router-outlet>',
  styles : ['.tran-main-content-div{position:absolute;top:0;right:0;bottom:0;left:0px;display:flex;flex-direction:column;min-width:450px}.tran-main-control-div{flex-grow:0;display:flex;flex-wrap:wrap;align-items:center;margin:0 8px 10px 8px;padding:0 8px;background-color:#eee;border:solid 1px #ddd;border-radius:4px}.tran-filter-control-div{flex-grow:0;display:flex;align-items:center;margin:0 8px 10px 8px;padding:0 8px;border-radius:4px}.tran-legend-item-div{margin:0 16px 0 2px}.tran-main-grid-div{flex-grow:1;position:relative;margin-top:15px;border-top:solid 1px #ccc}.tran-control-lbl{margin-right:4px}.tran-filter-radio{padding-left:10px;display:flex;align-items:center}.tran-main-control-break{flex-basis:100%;height:0}.tran-control-div{display:flex;align-items:center;margin:20px 0 10px 0;padding-left:20px;font-size:12px}.tran-ui-cell{position:relative;background-color:#f0f0f0;border-radius:4px;border:solid 1px #b8b8b8;padding:25px 15px 10px 25px;margin:0 10px;max-width:900px}.tran-ui-flex-field-div{margin:0 0 0 0;display:flex;align-items:center}.tran-ui-flex-field-lbl{white-space:nowrap;flex-wrap:nowrap}.tran-upper-div{flex-grow:0}.tran-lower-div{position:relative;flex-grow:1;border-top:solid 1px #ccc}.tran-ui-popup-edit{width:625px;max-width:625px;overflow:hidden}.tran-ui-popup-export{width:500px;max-width:500px}.tran-ui-dates-block{display:flex}.tran-cssClasses_Grid{border-top:solid 1px #bbb}.tran-cssClasses_Cell{border-right:solid 1px #ccc;padding:2px 4px !important;margin:0}.tran-cssClasses_EditableCell_incomplete{border:solid 1px orange !important}.tran-cssClasses_EditableCell_complete{border:solid 1px green !important}.tran-cssClasses_Grid_MS{border-bottom:none !important}.tran-cssClasses_Body_MS{border:solid 1px #b8b8b8;border-radius:2px;background-color:#f0f0f0}.tran-cssClasses_Cell_MS{padding:0 2px !important}.tran-list{width:75px;height:80px;border:solid 1px #b8b8b8;padding:2px;overflow-y:auto;background-color:#f0f0f0}.tran-list-button{margin:0 5px;font-size:18px}'],
  providers : []
})
export class TranslationComponent implements OnInit{


    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------


    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    //constructor(){
    //    //this.constructor.mapParams( this, arguments );
    //};

    //==================================
    // ngOnInit
    //==================================
    //ngOnInit(){
    //};
  
}

